/* ==========================================================================
   utopia-cart-builder.js  (Oct 2026)

   Replaces addToCart1() from assets/theme.js with an identical copy that
   also handles failure. cartBuilder() in theme.js is unchanged and still
   does the collecting; it calls addToCart1 by its global name, so it picks
   up this version automatically.

   WHY
   addToCart1 adds a system to the basket one component at a time. If any
   single add failed (a deleted or unpublished variant, a dropped connection)
   the chain simply stopped: the spinner and wait cursor never cleared and
   part of the system was left in the basket with no message.

   NOW
   On failure, every line from THIS system (matched on its _groupID) is
   removed from the basket, so nobody is left with half a build. Nothing else
   in the basket is touched. Then the buttons come back and the customer is
   told what happened. The success path is byte-for-byte the original:
   same requests, same order, same line properties, same redirect.

   WHY A SEPARATE FILE RATHER THAN EDITING theme.js
   theme.js is 166KB and theme files can only be written whole. This file is
   loaded from snippets/config-bar.liquid, which every configurator renders.
   The old addToCart1 in theme.js is now dead code and can be deleted the
   next time theme.js is edited for another reason.

   LOAD ORDER
   theme.js is loaded async, so on a page that renders the configurator
   inline this file can run first and theme.js would then redefine the old
   function. install() therefore runs immediately AND again on window load;
   async scripts always finish before the load event, so the second call
   always wins. On landing pages the configurator is fetched on demand, long
   after load, so the first call is enough. Running more than once is safe.
   ========================================================================== */

(function () {
  'use strict';

  var PHONE = '01563 574280';

  function cartBuilderFailed(groupID, xhr) {
    var detail = '';
    try { detail = (xhr && xhr.responseJSON && xhr.responseJSON.description) || ''; } catch (e) { /* ignore */ }

    function finish(cleaned) {
      jQuery('.loading').addClass('hidden');
      jQuery('#addtocart1').removeClass('hidden');
      jQuery('#addtocart2').removeClass('hidden');
      jQuery(document.body).css({ cursor: 'default' });
      window.alert(
        'Sorry, we couldn\u2019t add your system to the basket' + (detail ? ' (' + detail + ')' : '') + '. ' +
        (cleaned ? 'Nothing has been added. ' : 'Please check your basket before trying again. ') +
        'Try again, or call us on ' + PHONE + ' and we\u2019ll sort it for you.'
      );
    }

    jQuery.getJSON('/cart.js').done(function (cart) {
      var updates = {};
      var found = false;
      (cart.items || []).forEach(function (item) {
        if (item.properties && item.properties._groupID === groupID) {
          updates[item.key] = 0;
          found = true;
        }
      });
      if (!found) { finish(true); return; }
      jQuery.ajax({
        url: '/cart/update.js',
        type: 'post',
        dataType: 'json',
        data: { updates: updates }
      }).done(function () { finish(true); })
        .fail(function () { finish(false); });
    }).fail(function () { finish(false); });
  }

  /* Identical to the theme.js original apart from the .fail() handler. */
  function addToCart1(queue, groupCount, groupID) {
    var selectedSystem = jQuery('.pagename').attr('type');
    var selectedImage = jQuery('.sys-img').attr('src');
    var shipDate = jQuery('.ship-date').html();
    var productId = queue.shift();

    jQuery.ajax({
      url: '/cart/add.js',
      type: 'post',
      dataType: 'json',
      data: {
        quantity: 1,
        id: productId,
        properties: {
          _groupCount: groupCount,
          _groupID: groupID,
          _systemName: selectedSystem,
          _systemImage: selectedImage,
          _shipDate: shipDate
        }
      }
    }).done(function () {
      if (queue.length) {
        addToCart1(queue, groupCount, groupID);
      } else {
        jQuery(document.body).css({ cursor: 'default' });
        window.location = '/cart';
      }
    }).fail(function (xhr) {
      cartBuilderFailed(groupID, xhr);
    });
  }

  function install() {
    window.addToCart1 = addToCart1;
    window.cartBuilderFailed = cartBuilderFailed;
  }

  install();
  if (document.readyState !== 'complete') {
    window.addEventListener('load', install);
  }
})();